export const routes = [
  {
    path: '/painel-recursos',
    name: 'resource-dashboard',
    component: () => import('./components/ClosingEntry.vue'),
    meta: { requiresAuth: true },
  },
]

export default routes
